import React, { useEffect } from 'react';
import RouteErrorPage from './RouteErrorPage';
// import useMediaQuery from './hooks/useMediaQuery';
import GlobalData, { GlobalDataContext } from './GlobalData'
import Router from './Router';
import Main from './Main/Main';
//import CSP from './Main/CSP/CSP';
import PendoAnalytics from './Main/PendoAnalytics/PendoAnalytics';
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import EventView from './Main/EventView/EventView';
import SlimScheduleView from './Main/SlimScheduleView/SlimScheduleView';
import SessionView from './Main/SessionView/SessionView';
import HomeDashboard from './Main/HomeDashboard/HomeDashboard';
import EventsDashboard from './Main/EventsDashboard/EventsDashboard';
import TrainerDashboard from './Main/TrainerDashboard/TrainerDashboard';
import CommunityDashboard from './Main/CommunityDashboard/CommunityDashboard';
import BuilderDashboard from './Main/BuilderDashboard/BuilderDashboard';
import EventBlueprintManager from './Main/BuilderDashboard/EventBlueprintManager/EventBlueprintManager';
import ModuleBlueprintManager from './Main/BuilderDashboard/ModuleBlueprintManager/ModuleBlueprintManager';
import AdminImitatorLogin from './AdminImitatorLogin';
import ShareInterceptor from './ShareInterceptor';
import StandaloneAttendenceForm from './Main/StandaloneAttendenceForm/StandaloneAttendenceForm';
import StandaloneEventForm from './Main/StandaloneEventForm/StandaloneEventForm';
import Jobs from './Main/Jobs/Jobs';
import '@prosolve/common-components-ui/dist/styles.css'
import consoleOverride from './consoleOverride';
import { getClientSubdomain } from './utils';

consoleOverride();

// Used to wrap route and override title seen in the browser Tab --
const Page = (props) => {
  useEffect(() => {
    document.title = props.title || "";
  }, [props.title]);
  return (
    <>
      {getClientSubdomain() === 'star' &&
        <PendoAnalytics />
      }
      {props.children}
    </>
  )
};

export default () => {
  // const isMobileView = useMediaQuery('(max-width: 450px)');

  const globalData = new GlobalData();
  // globalData.setIsMobileView(isMobileView)

  const routes = [
    {
      path: "/",
      isPrivate: true,
      element: (routeProps) => (
        <Page title='ProSolve Events Portal'>
          <Main {...routeProps} />
        </Page>
      ),
      children: [
        {
          path: "home",
          element: <HomeDashboard />
        },
        {
          path: "home/event",
          element: <EventView />
        },
        {
          path: "home/event/session",
          element: <SessionView />
        },
        {
          path: "events",
          element: <EventsDashboard />
        },
        {
          path: "events/event",
          element: <EventView />
        },
        {
          path: "events/event/session",
          element: <SessionView />
        },
        {
          path: "trainer",
          element: <TrainerDashboard />
        },
        {
          path: "community",
          element: <CommunityDashboard />
        },
        {
          path: "design",
          element: <BuilderDashboard />
        },
        {
          path: "design/eventTemplate",
          element: <EventBlueprintManager />
        },
        {
          path: "design/sessionTemplate",
          element: <ModuleBlueprintManager />
        },
        {
          path: "jobs",
          element: <Jobs />
        },
      ],
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: "jobs/noheader",
      isPrivate: true,
      element: (routeProps) => (
        <Page title='ProSolve Events Portal'>
          <Jobs {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: "/adminImitatorLogin",
      element: (routeProps) => (
        <Page title='ProSolve Events Portal'>
          <AdminImitatorLogin {...routeProps} />
        </Page>
      ),
    },
    {
      path: "/forgotpassword",
      element: (routeProps) => (
        <Page title='ProSolve Authentication Portal'>
          <ForgotPassword {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: "/resetPassword",
      element: (routeProps) => (
        <Page title='ProSolve Authentication Portal'>
          <ResetPassword {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: "eventView",
      element: (routeProps) => (
        <Page title='ProSolve Event View'>
          <EventView {...routeProps} isPublicView={true} />
        </Page>
      )
    },
    {
      path: "eventView/session",
      element: (routeProps) => (
        <Page title='ProSolve Event View'>
          <SessionView {...routeProps} />
        </Page>
      ),
    },
    {
      path: "scheduleView",
      element: (routeProps) => (
        <Page title='ProSolve Event Schedule View'>
          <SlimScheduleView {...routeProps} />
        </Page>
      )
    },
    {
      path: "scheduleView/session",
      element: (routeProps) => (
        <Page title='ProSolve Event Schedule View'>
          <SessionView {...routeProps} />
        </Page>
      ),
    },
    {
      path: "share/:shareCode",
      element: (routeProps) => (
        <Page title='ProSolve Event View'>
          <ShareInterceptor {...routeProps} />
        </Page>
      )
    },
    {
      path: "attendance/:shareCode",
      element: (routeProps) => (
        <Page title='ProSolve Event View'>
          <StandaloneAttendenceForm {...routeProps} />
        </Page>
      )
    },
    {
      path: "logistics/:shareCode",
      element: (routeProps) => (
        <Page title='ProSolve Event View'>
          <StandaloneEventForm {...routeProps} />
        </Page>
      )
    },
  ]

  return (
    <GlobalDataContext.Provider value={globalData}>
      {/*<CSP />*/}
      <Router routes={routes} />
    </GlobalDataContext.Provider>
  )
}